import type { IconSvgObject } from './types';

const MergeIcon: IconSvgObject = [
  ["path", { d: "M15.996 6.99996C15.996 6.99996 13.05 3.00001 11.996 3C10.9419 2.99999 7.99599 7 7.99599 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9964 3.5V11.3431C11.9964 12.1606 11.9964 12.5694 11.8442 12.9369C11.6919 13.3045 11.4029 13.5935 10.8248 14.1716L3.99609 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.4961 15.5L19.9961 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MergeIcon;
